import type { PivotChartSpecPipeline, SpecPipeline, VChartSpecPipeline } from 'src/types'
import {
  animationMorph,
  datasetXY,
  backgroundColor,
  label,
  tooltip,
  discreteLegend,
  color,
  initPivot,
  datasetPivot,
  pivotDiscreteLegend,
  pivotIndicators,
  pivotAdapter,
  pivotIndicatorsAsRow,
  pivotGridStyle,
  pivotColumnDimensions,
  pivotRowDimensions,
  pointStyle,
  radarLineStyle,
  verticalCrosshairLine,
  pointStateDimensionHover,
  initRadar,
  radarAnimation,
  radarAreaStyle,
  radarAngleAxis,
  radarRadiusAxis,
  progressive,
  linearColor,
  colorAdapter,
  colorLegend,
  colorPointStyleFill,
  colorLineStyleFill,
  colorAreaStyleFill,
  pivotColorLegend,
  pivotHideIndicatorName,
  pivotTitle,
  addRegionPadding,
  fontFamilyTheme,
} from '../pipes'

const radar: VChartSpecPipeline = [
  fontFamilyTheme,
  initRadar,
  radarAnimation,
  colorAdapter(color, linearColor),
  backgroundColor,
  datasetXY,
  animationMorph,
  progressive,
  radarAngleAxis,
  radarRadiusAxis,
  label,
  tooltip({ titleEncoding: 'angle' }),
  colorAdapter(discreteLegend, colorLegend),
  verticalCrosshairLine,
  colorPointStyleFill(pointStyle),
  pointStateDimensionHover,
  colorLineStyleFill(radarLineStyle),
  colorAreaStyleFill(radarAreaStyle),
  // annotationPoint,
  // annotationVerticalLine,
  // annotationHorizontalLine,
  // annotationArea,
]

const pivotRadar: PivotChartSpecPipeline = [
  initPivot,
  pivotGridStyle,
  pivotIndicatorsAsRow,
  pivotHideIndicatorName,
  datasetPivot,
  pivotIndicators([
    fontFamilyTheme,
    initRadar,
    radarAnimation,
    addRegionPadding,
    colorAdapter(color, linearColor),
    backgroundColor,
    datasetXY,
    animationMorph,
    progressive,
    radarAngleAxis,
    radarRadiusAxis,
    label,
    tooltip({ titleEncoding: 'angle' }),
    verticalCrosshairLine,
    colorPointStyleFill(pointStyle),
    pointStateDimensionHover,
    colorLineStyleFill(radarLineStyle),
    colorAreaStyleFill(radarAreaStyle),
    // annotationPoint,
    // annotationVerticalLine,
    // annotationHorizontalLine,
    // annotationArea,
  ]),
  pivotRowDimensions,
  pivotColumnDimensions,
  pivotTitle,
  colorAdapter(pivotDiscreteLegend, pivotColorLegend),
]

export const radarSpecPipeline: SpecPipeline = [pivotAdapter(radar, pivotRadar)]
